import { atom } from "recoil";
import { ModalTypes } from "../components/modal";

export const ModalTypeState = atom<ModalTypes | null>({
  key: "modalTypeState",
  default: null,
});
